import PropTypes from 'prop-types'
import React, { Component } from 'react';
import get from 'lodash/get'
import ReactStars from 'react-stars'
import config from '../../config'
import moment from 'moment'

export default class ReviewActivity extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onStartSelect: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      starsEdit: true,
      data: this.props.data
    }
    console.log(this.props.data)
  }

  componentWillReceiveProps(props) {
    if (props.data) {
      this.setState({ data: props.data })
    }
  }

  render() {
    const { onStartSelect, tipClick } = this.props
    const { data } = this.state

    console.log('this.props', this.props)

    return (
      <div className="library__search-result search-result media">
        <div className="media-left reviewform__result__photo ">
          <img
            src={data.defaultPhoto ? `${config.imgApiUrl}/${get(data, `defaultPhoto.secret`)}/x60` : (data.avatar||'http://via.placeholder.com/86x60')}
            alt=""
          />
          {
            /*
             <br />
             {data.reviews.length === 0 || !data.reviews[0].description ? (
               <div className="reviewform__img_dates">{moment(this.props.createdAt).format(' MMM Y')}</div>
             ) : (
               ''
             )}
            */
          }

        </div>

        <div className="media-body">
          <h4 className="media-heading">
            {data.title || `${data.firstName} ${data.lastName}`} - {this.props.type}
          </h4>

          {data.reviews.length > 0 ? (
            <div>
              <div className="stars starts_small">
                <ReactStars
                  key={data.id}
                  count={5}
                  size={14}
                  value={data.reviews[0].score}
                  color1={'#e1e2df'}
                  color2={'#33b3de'}
                  edit={false}
                  half={false}
                />
              </div>


                <div>
                  { data.destination && (<div className="destination">Destination: {data.destination}</div>) }
                  { data.reviews[0].date && (<div className="dates">Date: {moment(data.reviews[0].date).format(' MMM Y')}</div>) }
                  { data.reviews[0].description && (<div className="description">{data.reviews[0].description}</div>) }
                </div>

              {
                /*
                 : (
                 <button
                   type="button"
                   className="btn btn-primary tip-button"
                   onClick={() => {
                     tipClick(data.reviews[0].id)
                   }}
                 >
                   Leave a tip
                 </button>)
                 */
              }

            </div>
          )
            : null

            /*
            (
            <div>
              <div className="stars starts_small">
                <ReactStars
                  key={data.id}
                  count={5}
                  onChange={e => {
                    this.setState({ starsEdit: false }, () => {
                      onStartSelect(e, data.id)
                    })
                  }}
                  size={14}
                  edit={this.state.starsEdit}
                  color1={'#e1e2df'}
                  color2={'#33b3de'}
                  half={false}
                />
                <div className="arrow_box">Click to rate</div>

              </div>
              <div>
                { data.destination && (<div className="destination">Destination: {data.destination}</div>) }
                { data.createdAt && (<div className="dates">Date: {moment(data.createdAt).format(' MMM Y')}</div>) }
                { data.reviews.length && data.reviews[0].description ? (<div className="description">{data.reviews[0].description}</div>) : '' }
              </div>
            </div>
            )*/
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/Rewiev/ReviewActivity.js